/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ngf-control-hint',
    templateUrl: './ngf-control-hint.component.html',
    styleUrls: ['./ngf-control-hint.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NgfControlHintComponent {

}
